module.exports = "/images/dotag-logo_gray.png?e7103d02441da987ed0c1aad6e7f8a5a";